import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';
import { DefaultDaysBoolean } from 'anchor-shared/lib/model/interface/vesselAvailabilityInterfaces';

@Component({
  selector: 'app-day-selection',
  templateUrl: './day-selection.component.html',
  styleUrls: ['./day-selection.component.scss'],
})
export class DaySelectionComponent implements OnInit {
  days: string[] = ['sun', 'mon', 'tues', 'wed', 'thurs', 'fri', 'sat'];

  daysObj: DefaultDaysBoolean = {
    sun: false,
    mon: false,
    tues: false,
    wed: false,
    thurs: false,
    fri: false,
    sat: false,
  };
  selectedDays: string[] = [];

  @Input() productOffering: BehaviorSubject<Partial<ProductOffering>>;

  constructor(private _fb: FormBuilder) {}

  ngOnInit() {
    this.initializeDays();
  }

  getClassForDay(day) {
    if (this.selectedDays.includes(day)) {
      return 'day-box-selected';
    }
    return 'day-box';
  }

  clickDay(day: string) {
    // Setting selected day to true/false
    this.daysObj[day] = !this.daysObj[day];

    // Determining whether or not day is selected for css class
    if (this.selectedDays.includes(day)) {
      this.selectedDays = this.selectedDays.filter(
        (selectedDay) => selectedDay !== day,
      );
    } else {
      this.selectedDays.push(day);
    }

    this.productOffering.next({
      ...this.productOffering.value,
      days: this.daysObj,
    });
  }

  private initializeDays() {
    if (this.productOffering.value.days) {
      this.daysObj = this.productOffering.value.days;

      for (let day in this.daysObj) {
        if (this.daysObj[day]) {
          this.selectedDays.push(day);
        }
      }
    }
  }
}
